import { render, staticRenderFns } from "./addTopic.vue?vue&type=template&id=257ca092&scoped=true"
import script from "./addTopic.vue?vue&type=script&lang=js"
export * from "./addTopic.vue?vue&type=script&lang=js"
import style0 from "./addTopic.vue?vue&type=style&index=0&id=257ca092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ca092",
  null
  
)

export default component.exports